module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/~/core-js/library/modules/_iter-step.js
// module id = 397
// module chunks = 0